import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { AdminWarningDialogComponent } from './admin-warning-dialog.component';
import { DialogsService } from '../../../../../core/services/dialog.service';

@NgModule({
  imports: [MatButtonModule, CommonModule],
  entryComponents: [AdminWarningDialogComponent],
  declarations: [AdminWarningDialogComponent],
  exports: [AdminWarningDialogComponent],
  providers: [DialogsService],
})
export class AdminWarningDialogModule {}
